<template>
  <div class="news">
    <div
      v-if="floatVisible"
      class="float-win"
      :style="{ left: floatLeft + 'px', top: floatTop + 'px' }"
    >
      <button style="display: none;" type="button" class="float-close" @click="closeFloat">关闭</button>
      <img :src="floatImg" alt="铸牢中华民族共同体意识——贵州汉方药业有限公司">
    </div>
    <drug-guide title="企业公告" :headimg="notHead" :enimg="enImg"></drug-guide>
    <div class="newslist">
      <div class="newsitem" v-for="(item, index) in newsList" :key="index" @click="getDetail(item.id)">
        <div class="newsitem-img">
          <img :src="item.thumb" alt="">
        </div>
        <div class="newsitem-con">
          <div class="newsitem-title">{{ item.title }}</div>
          <div class="newsitem-desc">{{ item.bref }}</div>
          <div class="newsitem-dot">
            <div class="newsitem-time">
              <img :src="timeImg" alt="">
              <div>{{ item.ctime }}</div>
            </div>
            <div class="newsitem-more">
              <div>MORE</div>
              <img :src="rightImg" alt="">
            </div>
          </div>
        </div>
      </div>
      <el-pagination class="workpage" background layout="prev, pager, next" :total="total" prev-text="上一页" next-text="下一页" @current-change="currentChange"></el-pagination>
    </div>
    <drug-footer></drug-footer>
  </div>
</template>

<script>
import DrugFooter from "../../components/DrugFooter";
import DrugGuide from "../../components/DrugGuide";
import { getCate, getList } from "@/api/index";
export default {
  name: "Notice",
  components: {
    DrugFooter,
    DrugGuide
  },
  data() {
    return {
      notHead: "static/images/notice/not-head.png",
      enImg: "static/images/notice/not-en.png",
      timeImg: "static/images/news/news-time.png",
      rightImg: "static/images/news/news-right.png",
      floatImg: "static/images/notice/float-banner.jpg",
      floatVisible: true,
      floatLeft: 24,
      floatTop: 120,
      floatDx: 1,
      floatDy: 1,
      floatTimer: null,
      newsList: [],
      page: 1,
      total: 0
    }
  },
  computed: {
    pid: {
      get () {
        return this.$store.state.pid;
      }
    },
  },
  watch: {
    '$store.state.keyword'(val) {
      var activeVal = this.$store.state.activeVal;
      if(activeVal == 4) {
        getList(this.pid, null, this.page, val).then((res) => {
          if(res.data.code == 1) {
            this.newsList = res.data.data.rows;
            this.total = res.data.data.total;
          }
        })
      }
    }
  },
  methods: {
    // 分页
    currentChange(index) {
      this.page = index;
      this.getNewsList();
    },
    // 详情跳转
    getDetail(id) {
      this.$router.push({
        path: "/notice/detail",
        query: { id }
      })
    },

    // 获取列表数据
    getNewsList() {
      getList(this.pid ? this.pid : 3, null, this.page, "").then((res) => {
        if(res.data.code == 1) {
          this.newsList = res.data.data.rows;
          this.total = res.data.data.total;
        }
      })
    },
    moveFloat() {
      var width = 340;
      var height = 141;
      var minTop = 90;
      var maxLeft = Math.max(0, window.innerWidth - width);
      var maxTop = Math.max(minTop, window.innerHeight - height);
      var nextLeft = this.floatLeft + this.floatDx;
      var nextTop = this.floatTop + this.floatDy;
      if (nextLeft <= 0 || nextLeft >= maxLeft) {
        this.floatDx = -this.floatDx;
        nextLeft = Math.min(maxLeft, Math.max(0, nextLeft));
      }
      if (nextTop <= minTop || nextTop >= maxTop) {
        this.floatDy = -this.floatDy;
        nextTop = Math.min(maxTop, Math.max(minTop, nextTop));
      }
      this.floatLeft = nextLeft;
      this.floatTop = nextTop;
    },
    closeFloat() {
      this.floatVisible = false;
      clearInterval(this.floatTimer);
      this.floatTimer = null;
    }
  },
  mounted() {
    this.$store.commit("getactive", 4);
    this.getNewsList();
    this.floatLeft = Math.max(24, window.innerWidth - 380);
    this.floatTimer = setInterval(this.moveFloat, 30);
  },
  beforeDestroy() {
    clearInterval(this.floatTimer);
  }
}
</script>

<style lang="scss" scoped>
.news {
  .float-win {
    position: fixed;
    z-index: 1100;
    width: 340px;
    pointer-events: none;
    .float-close {
      position: absolute;
      top: 6px;
      right: 6px;
      z-index: 1;
      pointer-events: auto;
      border: 0;
      padding: 2px 8px;
      font-size: 12px;
      line-height: 18px;
      color: #fff;
      background: rgba(0, 0, 0, 0.45);
      cursor: pointer;
    }
    img {
      width: 100%;
      display: block;
    }
  }
  .newslist {
    width: 80%;
    height: auto;
    overflow: hidden;
    margin: auto;
    .newsitem {
      padding: 28px 20px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      background-color: #fff;
      margin-top: 20px;
      cursor: pointer;
      .newsitem-img {
        // width: 430px;
        height: 240px;
        img {
          // width: 100%;
          height: 100%;
          display: block;
        }
      }
      .newsitem-con {
        padding-right: 20px;
        width: 60%;
        height: 240px;
        display: flex;
        flex-direction: column;
        justify-content: space-around;
        .newsitem-title {
          width: 95%;
          height: 40px;
          line-height: 40px;
          font-size: 26px;
          font-family: "PingFang SC-Medium", "PingFang SC";
          font-weight: 500;
          color: #223037;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }
        .newsitem-desc {
          width: 95%;
          font-weight: 400;
          color: #7C828A;
          line-height: 28px;
          overflow: hidden;
          display: -webkit-box;
          -webkit-box-orient: vertical;
          -webkit-line-clamp: 3; /*最大行数*/
        }
        .newsitem-dot {
          width: 100%;
          height: 40px;
          display: flex;
          justify-content: space-between;
          align-items: center;
          .newsitem-time {
            display: flex;
            align-items: center;
            color: #4392EC;
            img {
              width: 16px;
              height: 16px;
              margin-right: 5px;
            }
          }
          .newsitem-more {
            width: 110px;
            height: 40px;
            display: flex;
            align-items: center;
            justify-content: center;
            border: 1px solid #ddd;
            color: #7C828A;
            img {
              width: 16px;
              height: 15px;
              margin-left: 5px;
            }
          }
        }
      }
    }
    .workpage {
      width: 90%;
      margin: 40px auto;
      display: flex;
      align-items: center;
      justify-content: center;
    }
  }
}

// 分页器样式
.news /deep/ .el-pagination.is-background {
  color: #909090;
  font-weight: 400;
}
.news /deep/ .el-pagination.is-background .el-pager li {
  width: 38px;
  height: 40px;
  line-height: 40px;
  box-sizing: border-box;
  margin: 0 5px;
  font-size: 16px;
}
// 上一页/下一页
.news /deep/ .el-pagination.is-background button {
  height: 40px;
  padding: 0 10px;
}
.news /deep/ .el-pagination.is-background button span {
  font-size: 16px;
}
</style>


// WEBPACK FOOTER //
// src/pages/notice/notice.vue